import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../Common/CommonCardHeader";
import { Rating } from "react-simple-star-rating";
import { CurrentRatingBar } from "../../../Constant";
import { CURRENT_RATING } from "../../../Data/Bonus Ui/Rating";
import { Btn } from "../../../AbstractElements";
import { useState } from "react";
import { Repeat } from "react-feather";

const CurrentRating = () => {
  const [rating, setRating] = useState(2);

  const handleRatingChange = (newRating:number) => setRating(newRating);

  const handleRatingReset = () => setRating(0);

  return (
    <Col xl="4" md="6">
      <Card>
        <CommonCardHeader title={CurrentRatingBar} span={CURRENT_RATING} />
        <CardBody>
          <div style={{ direction: "ltr", touchAction: "none" }}>
            <Rating initialValue={rating} onClick={handleRatingChange} />
            <Btn className="border-0" onClick={handleRatingReset}>{rating}
              <Repeat size={15} className="ms-2"  />
            </Btn>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default CurrentRating;
